/**
 * Impersonation ("view as") is a client-side read-only lens, not a real
 * session switch. The admin stays authenticated as themselves; this store
 * just says "render the staff-view page for this person, and refuse to
 * render anything else." See docs/decisions/2026-07-31-impersonation-scope.md
 * for why it is scoped this way rather than embedding the POS app.
 */

import { create } from 'zustand';

export interface ImpersonationTarget {
  id: string;
  displayName: string;
  code: string;
}

interface ImpersonationState {
  target: ImpersonationTarget | null;
  start(target: ImpersonationTarget): void;
  stop(): void;
}

export const useImpersonationStore = create<ImpersonationState>((set) => ({
  target: null,
  start: (target) => set({ target }),
  stop: () => set({ target: null }),
}));
